import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { loadContactDataSaga } from "./sagas/loadContactDataSaga";
import { contactSelectionModalProvider } from "./provider/provider";
import { setContactsSaga } from "./sagas/setContactsSaga";
import { CustomContactTreeEngine } from "./components/CustomContactTreeEngine";

const contactDataModule = (): Module => ({
	id: "ContactDataModule",
	views: () => viewComponentProvider,
	sagas: () => [loadContactDataSaga, setContactsSaga],
	dataProviders: () => [contactSelectionModalProvider]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	CustomContactTreeEngine
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default contactDataModule;
